<div class="desktop edp-card-widget card">
    <div class="card-header">
        <span class="card-title">{{ 'pt.edp.edponline.smartnow.title' | translate }}</span>
        <span class="card-icon">
            <i class="icon-edponline-Bop-023"></i>
        </span>
    </div>

    <div class="card-body">
        <div [innerHTML]="'pt.edp.edponline.smartnow.text' | translate"></div>
        <div class="mb-2 mt-auto pt-4">
            <button class="btn btn-primary w-100" (click)="openSmartnow()">
                <span>{{ 'pt.edp.edponline.smartnow.action' | translate }}</span>
            </button>
        </div>
    </div>
</div>

<div class="mobile edp-card-widget card">
    <div class="card-header">
        <span class="card-title-small">{{ 'pt.edp.edponline.smartnow.title' | translate }}</span>
        <span class="card-icon">
          <i class="icon-edponline-Bop-023"></i>
      </span>
    </div>
    <div class="card-body">
      <div [innerHTML]="'pt.edp.edponline.smartnow.text' | translate"></div>
        <div class="mb-2 mt-auto pt-4">
            <button class="btn edp-btn-tertiary w-100" (click)="openSmartnow()">
                <span>{{ 'pt.edp.edponline.smartnow.action' | translate }}</span>
            </button>
        </div>
    </div>
</div>
